import axios from "axios";

export const branchApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/stk-branches`,
  headers: {
    "Content-Type": "application/json",
  },
});
